import { z } from 'zod';
import type { RefinementCtx, ZodEffects, ZodObject, ZodRawShape } from 'zod';

const isSameMarkerMessage = 'Please select a new marker.';

const unrefinedReallocateResponseFormSchema = z.object({
  // Rather than allowing no organisation user, we're loading the old one here. This gives us some
  // flexibility if we want to change the Combo Box to show already allocated markers in the list
  // but is not strictly required with the currently implementation.
  organisationUserId: z.number()
});

export type ReallocateResponseFormValues = z.infer<typeof unrefinedReallocateResponseFormSchema>;

function getSameMarkerSchema(
  initialOrganisationUserId: number
): ZodEffects<ZodObject<ZodRawShape>> {
  return unrefinedReallocateResponseFormSchema.superRefine(
    (formData: ReallocateResponseFormValues, ctx: RefinementCtx) => {
      if (formData.organisationUserId === initialOrganisationUserId) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: isSameMarkerMessage,
          path: ['organisationUserId']
        });
      }
    }
  );
}

export function reallocateResponseFormSchema(
  organisationUserId: number
): ZodEffects<ZodObject<ZodRawShape>> | ZodObject<ZodRawShape> {
  if (organisationUserId) {
    return getSameMarkerSchema(organisationUserId);
  }
  return unrefinedReallocateResponseFormSchema;
}
